// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CreatePassword-module__createPasswordForm___L8USZ p{margin:0 0 20px 0}.CreatePassword-module__createPasswordForm___L8USZ .CreatePassword-module__buttonRow___GVAWW{margin-top:16px}`, "",{"version":3,"sources":["webpack://./src/components/routeComponents/Authentication/CreatePassword.module.scss"],"names":[],"mappings":"AACE,qDACE,iBAAA,CAGF,6FACE,eAAA","sourcesContent":[".createPasswordForm {\n  p {\n    margin: 0 0 20px 0;\n  }\n\n  .buttonRow {\n    margin-top: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"createPasswordForm": `CreatePassword-module__createPasswordForm___L8USZ`,
	"buttonRow": `CreatePassword-module__buttonRow___GVAWW`
};
export default ___CSS_LOADER_EXPORT___;
